import { render } from "./index.vue?vue&type=template&id=f3e0af04&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=f3e0af04&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3e0af04"],['__file',"src/components/BaseUi/Dropdown/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f3e0af04"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f3e0af04', __exports__)) {
    api.reload('f3e0af04', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=f3e0af04&scoped=true", () => {
    api.rerender('f3e0af04', render)
  })

}


export default __exports__